import React from 'react';

// Shared table shell only: each planner owns its data contract and row presentation.
const CategoryBreakdownTable = ({ title, currency, hasChangeCols, children }) => (
  <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-3 sm:p-4 mb-6">
    <div className="mt-0">
      <table className="w-full">
        <thead>
          <tr className="border-b dark:border-gray-700 text-xs">
            <th className="py-1 text-left dark:text-white">{title}</th>
            <th className="py-1 text-left dark:text-white">Amount ({currency})</th>
            <th className={`py-1 text-left dark:text-white${hasChangeCols ? ' whitespace-nowrap' : ''}`}>{hasChangeCols ? 'Portfolio %' : 'Alloc %'}</th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  </div>
);

export default CategoryBreakdownTable;
